(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kt-about-us"] && !Shopify.designMode) return;
  try {
    
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const aboutJourneyItems = gsap.utils.toArray('.about-journey__item');
let aboutStory = document.querySelector('.about-story');

const aboutStoryNavigation = aboutStory.querySelectorAll(
    '.about-journey__navigation .navigation-item'
);
const aboutStoryPagination = aboutStory.querySelectorAll(
    '.about-journey__pagination .pagination-item'
);

// Height of navbar
const navbarEle = document.querySelector('header[x-data="navbar"]');
const anouncementBar = document.querySelector('.announcement-bar');
const header = document.querySelector('.header');
const totalHeightHeader = anouncementBar.clientHeight + header.clientHeight;

// HANDLE NAVIGATION ABOUT STORY
function handlePaginationSlider() {
    let index = parseInt(this.dataset.index) - 1;

    if (window.innerWidth > 992) {
        const sliderEle = aboutJourneyItems[0];

        // Offset top about journey
        const aboutJourney = document.querySelector('.about-section.about');
        const aboutJourneyWrapper = document.querySelector(
            '.about-journey__wrapper'
        );
        // const offsetTop = aboutJourney.offsetTop + aboutJourney.clientHeight
        const offsetTop = aboutJourney.offsetTop;

        // Height of about journey item
        const heightOfItem = sliderEle.clientHeight * index;

        console.log('Height Of Item:', heightOfItem);

        gsap.to(window, {
            // scrollTo: offsetTop + heightOfItem - navbarEle.clientHeight,
            // scrollTo: offsetTop + heightOfItem,
            scrollTo: offsetTop + heightOfItem - totalHeightHeader,
        });

        return;
    }

    // Change active pagination btn
    const btnWrapper = document.querySelector('.about-journey__navigation');
    console.log('BTN WRAPPER:', btnWrapper);
    const prevActiveBtn = btnWrapper.querySelector('.navigation-item--active');
    if (prevActiveBtn) {
        prevActiveBtn.classList.remove('navigation-item--active');
    }
    aboutStoryNavigation[index].classList.add('navigation-item--active');

    // Transform Element
    aboutJourneyItems.forEach((item) => {
        const translate = -100 * index;
        item.style.transform = `translateX(${translate}%)`;
        item.style.transition = 'all 0.5s ease-out';
    });

    // Change pagination state
    const paginationWrapper = document.querySelector(
        '.about-journey__pagination'
    );
    const allPaginationBtn =
        paginationWrapper.querySelectorAll('.pagination-item');
    const prevActivePagination = paginationWrapper.querySelector(
        '.pagination-item--active'
    );
    if (prevActivePagination) {
        prevActivePagination.classList.remove('pagination-item--active');
    }
    allPaginationBtn[index].classList.add('pagination-item--active');
}
aboutStoryNavigation.forEach((btn) => {
    btn.addEventListener('click', handlePaginationSlider);
});
aboutStoryPagination.forEach((btn) => {
    btn.addEventListener('click', handlePaginationSlider);
});

function changeNavigationAboutJourney(self) {
    // REMOVE ACTIVE NAVIGATION
    const activeClassName = 'navigation-item--active';
    const navigationActive = aboutStory.querySelector(`.${activeClassName}`);
    if (navigationActive) {
        navigationActive.classList.remove(activeClassName);
    }

    // REMOVE ACTIVE PAGINATION
    const activePaginationClassName = 'pagination-item--active';
    const paginationActive = aboutStory.querySelector(
        `.${activePaginationClassName}`
    );
    // console.log('About Story from Pagination', aboutStory);
    // console.log('Pagination Active:', paginationActive);

    if (paginationActive) {
        paginationActive.classList.remove(activePaginationClassName);
    }

    // GET INDEX
    const index =
        self.progress == 1
            ? aboutJourneyItems.length - 1
            : Math.floor(self.progress * aboutJourneyItems.length);

    // ADD ACTIVE NAVIGATION
    const currentNavigation = aboutStoryNavigation[index];
    currentNavigation.classList.add(activeClassName);

    // ADD ACTIVE PAGINATION
    const currentPagination = aboutStoryPagination[index];
    currentPagination.classList.add(activePaginationClassName);
}

const aboutStoryTopEle = document.querySelector('.about-story.about-story-block');

const mm = gsap.matchMedia();
mm.add('(min-width: 992px', () => {
    gsap.to(aboutJourneyItems, {
        xPercent: -100 * (aboutJourneyItems.length - 1),
        ease: 'none',
        scrollTrigger: {
            // markers: true,
            trigger: '.about-story.about-journey',
            scrub: 1,
            pin: true,
            snap: {
                snapTo: 1 / (aboutJourneyItems.length - 1),
                directional: false,
                delay: 0,
                duration: {
                    min: 0,
                    max: 0,
                },
                ease: 'none',
            },
            start: () => {
                // return `${aboutStory.clientHeight}px bottom`

                // if (window.innerWidth < 992) {
                //   if (document.querySelector('.about-story.about-story-block')) {
                //     return `bottom bottom`
                //   }
                //   return `top +=${totalHeightHeader}px`
                // }
                // return `bottom bottom`

                if (aboutStoryTopEle) {
                    return `bottom bottom`;
                } else {
                  return `top +=${totalHeightHeader}px`;
                }
            },
            end: () => {
                const totalItem = aboutJourneyItems.length - 1;
                // return `+=${aboutJourneyItems[0].clientHeight * totalItem + navbarEle.clientHeight} bottom`

                // if (window.innerWidth < 992) {
                //   return `+=${aboutJourneyItems[0].clientHeight * totalItem} +=${totalHeightHeader}px`;
                // }
                // return `+=${aboutJourneyItems[0].clientHeight * totalItem}px bottom`

                return `+=${aboutJourneyItems[0].clientHeight * totalItem} +=${totalHeightHeader}px`;
            },
            onUpdate: changeNavigationAboutJourney,
            onSnapComplete: changeNavigationAboutJourney,
        },
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-collection-page"] && !Shopify.designMode) return;
  try {
    
  // document.addEventListener('DOMContentLoaded', function() {
  //   const paginateRecipe = new Ajaxinate({
  //     container: "#products-mainpage-list",
  //     pagination: "#products-mainpage-pagination",
  //     loadingText: 'Loading...',
  //   });
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-main-product-dropdown"] && !Shopify.designMode) return;
  try {
    
  const dropdownRelatedRecipe = document.querySelector('.product-dropdown__item--related-recipe.wrapper');
  if (dropdownRelatedRecipe) {
    new Swiper(dropdownRelatedRecipe, {
      slidesPerView: 3,
      spaceBetween: 12,
      rewind: true,
      scrollbar: {
        el: '.product-dropdown__item--related-recipe .swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 12,
        }
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-main-recipe-2"] && !Shopify.designMode) return;
  try {
    
  function initKtRecipeTwoSlider() {
    let KTRecipeTwoSlider;
    const sliderProp = {
        spaceBetween: 16,
        rewind: true,
        speed: 300
    }
    if (window.innerWidth < 576) {
        KTRecipeTwoSlider = new Swiper('.kt-recipe-2__list', sliderProp)
    }
    
    window.addEventListener('resize', () => {
      const viewportWidth = window.innerWidth;
      
      if (KTRecipeTwoSlider && viewportWidth >= 576) {
          // console.log("DESKTOP AGAIN")
          setTimeout(() => {
              KTRecipeTwoSlider.disable()
              KTRecipeTwoSlider.destroy()
          }, 400)
      }
    
      if (!KTRecipeTwoSlider && viewportWidth < 576) {
        KTRecipeTwoSlider = new Swiper('.kt-recipe-2__list', sliderProp)
        return;
      }
    
      if (viewportWidth < 576) {
        // console.log("MOBILE AGAIN")
        setTimeout(() => {
          KTRecipeTwoSlider.enable()
          return
        }, 300)
    
      }
    })
  }

  initKtRecipeTwoSlider();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-main-recipe"] && !Shopify.designMode) return;
  try {
    
  // RECIPE - MOBILE
  const recipeMobile = new Swiper(".recipe__item--mobile", {
      loop: true,
      pagination: {
          el: ".recipe__item--mobile .slider-pagination",
          bulletActiveClass: "active",
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-related-products"] && !Shopify.designMode) return;
  try {
    
  // RELATED PRODUCTS
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        return recommendations
      }).
      then((recommendations) => {
        setTimeout(() => {      
          const productsSubpageRelated = new Swiper(
            '.products-subpage__related .body__slider',
            {
              rewind: true,
              slidesPerView: 3,
              spaceBetween: 32,
              navigation: {
                  nextEl: '.products-subpage__related .body__slider-navigation .next',
                  prevEl: '.products-subpage__related .body__slider-navigation .prev',
              },
              breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 8,
                },
                576: {
                    spaceBetween: 16,
                },
                993: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
              },
            }
          );
        }, 1)
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-running-text"] && !Shopify.designMode) return;
  try {
    
    new Swiper('.running-text__slider', {
        slidesPerView: 4,
        loop: true,
        spaceBetween: 16,
        speed: 5000,
        autoplay: {
            delay: 0,
            pauseOnMouseEnter: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            576: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 4
            }
        },
        on: {
            beforeInit: (swiper) => {
                console.log(swiper)
                const sliderEle = swiper.el
                const runningTextEl = sliderEle.closest('[data-type]')

                const isSlider = runningTextEl.dataset.type == 'slider-autoplay'

                // Check type is `normal` or `slider-autoplay`
                if (isSlider) {
                    swiper.params.speed = 2000
                    swiper.params.autoplay.delay = 1000
                    return
                }

                swiper.params.speed = 5000
                swiper.params.autoplay.delay = 0
                return
            },
            afterInit: (swiper) => {
                // console.log(swiper)

                const slidesEle = swiper.slides
                slidesEle.forEach((ele, idx) => {
                    if ((idx + 1) % 2 == 0) {
                        ele.classList.add('running-text__item--even')
                    }
                    ele.classList.add('running-text__item--odd')
                });
            }
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-slider-pin"] && !Shopify.designMode) return;
  try {
    
    
  if (Shopify.designMode) {
    // This will only render in the theme editor
    document.addEventListener('shopify:section:load', () => {
      scrollToPin();
    })
  }

  if (Shopify.visualPreviewMode) {
    // This will only execute inside the theme editor's visual preview
    document.addEventListener('shopify:section:load', () => {
      scrollToPin();
    })
  }

  
  function scrollToPin() {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)
  
      // Prepare data
      const anouncementBar = document.querySelector('.announcement-bar');
      const header = document.querySelector('.header');
      const totalHeightNavbar = anouncementBar.clientHeight + header.clientHeight;
      // console.log('Navbar Ele:', totalHeightNavbar)
    
      const sliderPinEle = document.querySelector('.slider-pin')
      const parentSliderPinEle = sliderPinEle.parentElement
      const sliderItemList = sliderPinEle.querySelectorAll('.slider-pin__item')
      const sliderPinStyle = window.getComputedStyle(sliderPinEle)
      const paddingTopSliderPin = parseInt(sliderPinStyle.paddingBlockStart)
      // console.log('Slider Pin:', sliderPinEle);
  
      // Get offset of navbar
      sliderPinEle.style.setProperty('--offset-top', `${totalHeightNavbar}px`)
  
      function changePaginationScroll(self) {
          // console.log(self.progress)
          // Remove nav pin when leave on start
          if (self.progress == 0) {
              const navEle = document.querySelector('.nav-wrapper.nav-pin')
              if (navEle && navEle.classList.contains('nav-pin')) {
                  navEle.classList.remove('nav-pin')
              }
          }
  
          // Pin navbar on start scrolling
          if (self.progress > 0 && self.progress !== 1) {
              pinNavbar()
          }
  
          // Prepare index data
          const tempIndex = Math.floor(self.progress * self.vars.data.totalItem)
          const activeIndex = self.progress < 1 ? tempIndex + 1 : tempIndex;
  
          // Remove active pagination
          const activePaginationEle = document.querySelector('.slider-pin__pagination span.active');
          if (activePaginationEle) {
              activePaginationEle.classList.remove('active')
          }
  
          // Add active pagination
          const paginationEle = document.querySelector(`.slider-pin__pagination span[data-index="${activeIndex}"]`)
          paginationEle.classList.add('active')
      }
  
      function pinNavbar(type = 'add') {
          // Type => add || remove
          // Check if navbar is hide or not
          const headerEle = document.querySelector('header.down')
          if (headerEle) {
              const navbarEle = headerEle.querySelector('.nav-wrapper')
              if (type == 'add') {
                  navbarEle.classList.add('nav-pin')
                  return
              }
              navbarEle.classList.remove('nav-pin')
              return
          }
      }
  
      // Prepare Ele GSAP
      const mm = gsap.matchMedia();
      const slidersItem = gsap.utils.toArray('.slider-pin__item');
      mm.add("(min-width: 992px)", () => { gsap.to(slidersItem, {
            yPercent: -100 * (slidersItem.length - 1),
            ease: 'none',
            scrollTrigger: {
                data: {
                    totalItem: slidersItem.length
                },
                // markers: true,
                trigger: '.slider-pin',
                start: () => {
                  return 'top top';
                },
                end: (self) => {
                    const itemEle = document.querySelector('.slider-pin__item')
                    let totalItemsEle = document.querySelectorAll('.slider-pin__item').length
                    // totalItemsEle = totalItemsEle > 3 ? (totalItemsEle + 1) : totalItemsEle;
                    return `+=${itemEle.clientHeight * totalItemsEle} top`
                },
                pin: true,
                scrub: 1,
                snap: {
                    snapTo: 1 / (slidersItem.length - 1),
                    directional: false,
                    delay: 0,
                    duration: {
                        min: 0,
                        max: 0,
                    },
                    ease: 'none',
                },
                onUpdate: changePaginationScroll,
                // onSnapComplete: changePaginationScroll,
                onEnterBack: () => pinNavbar(),
                onLeave: () => pinNavbar('remove'),
                onLeaveBack: () => pinNavbar('remove'),
            }
        });
      });
  
      // Handle Pagination on Clicked
      const paginationBtn = document.querySelectorAll('.slider-pin__pagination > span')
      paginationBtn.forEach(btn => {
          btn.addEventListener('click', function() {
              // Temp disable button
              paginationBtn.forEach(btn => {
                  btn.style.pointerEvents = 'none'
  
                  // Enable Button
                  setTimeout(() => {
                      btn.style.pointerEvents = 'auto'
                  }, 1000)
              })
  
              const index = this.dataset.index
              const sliderPinEle = this.closest('.slider-pin')
              const sliderPinStyle = window.getComputedStyle(sliderPinEle)
              const paddingTopSliderPin = parseInt(sliderPinStyle.paddingBlockStart)
  
              const parentSliderPinEle = sliderPinEle.parentElement
              const sliderItemList = sliderPinEle.querySelectorAll('.slider-pin__item')
              const heightOfSliderItem = parentSliderPinEle.clientHeight / sliderItemList.length
  
              const scrollToVal = paddingTopSliderPin + parentSliderPinEle.offsetTop + (heightOfSliderItem * (index - 1))

              console.log(scrollToVal);
  
              gsap.to(window, {
                  scrollTo: scrollToVal
              })
          })
      })
  }
  
  scrollToPin();

  } catch(e) { console.error(e); }
})();
})();
